import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function usePublishedDiscourseState() {
  return useAppState();
}

export function usePublishedDiscourseActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      documents: [],
      pageNumber: 1,
      moreDocumentsAvailable: true,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => {
      const existingDocuments = appState.documents || [];
      // Set for O(1) lookups when deduplicating against existing documents
      // Set.has() is O(1) lookup vs Array.includes() which is O(n), so for a feed with many documents the filtering is faster
      const existingIds = new Set(existingDocuments.map(d => d.id));
      const uniqueNewDocuments = (response.documents || []).filter(d => !existingIds.has(d.id));

      return {
        ...appState,
        ...response,
        documents: existingDocuments.concat(uniqueNewDocuments),
        loading: false,
      };
    });
  }

  function onError(feedback) {
    dispatch((appState) => ({
      ...appState,
      ...feedback,
      loading: false,
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
